import React from 'react'
import Layout from '../components/layout'
import ProductListing from '../components/ProductListing'
import { graphql } from 'gatsby'

function CategoryListing(props) {
	return (<Layout>
	  	<ProductListing {...props}/>
	  </Layout>
	)
}
export default CategoryListing;


export const CategoryQuery = graphql`
  query($categoryID: String!){
		allCommerceProductCommerceProduct(filter: {relationships: {field_product_categories: {elemMatch: {id: {eq: $categoryID}}}}}) {
			nodes {
			title
			path {
				alias
			}
			relationships {
				variations {
					id
					price{
			    	number
		    	}
		    	relationships{
			    	field_images{
				    	localFile {
					    	childImageSharp {
						   	 fluid {
							   	 ...GatsbyImageSharpFluid
						    	}
					    	}
				    	}
			    	}
		    	}  
        }
      }
    }
  }
}
`;